// extracted by mini-css-extract-plugin
export default {"dialog":"Modal-module__dialog__ZjKBQ","overlay":"Modal-module__overlay__nq7BM","content":"Modal-module__content__OodvI","close":"Modal-module__close__bc_jJ"};